import { RouteConfig } from 'vue-router';
const PAGE_TITLE = '“奋进新征程 共绘新时代”两江新区公益广告平面设计大赛';
const baseUrl = '20220810LJGYGG';
const route: RouteConfig = {
  path: `/${baseUrl}`,
  name: baseUrl,
  component: () => import('./ViewHolder.vue'),
  redirect: `/${baseUrl}/home`,
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'home',
      name: `${baseUrl}-home`,
      component: () => import('./pages/Home.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'activity',
      name: `${baseUrl}-activity`,
      component: () => import('./pages/Activity.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'rule',
      name: `${baseUrl}-rule`,
      component: () => import('./pages/Rule.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'news',
      name: `${baseUrl}-news`,
      component: () => import('./pages/News.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    {
      path: 'homedetail',
      name: `${baseUrl}-homedetail`,
      component: () => import('./pages/HomeDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'activitydetail',
      name: `${baseUrl}-activitydetail`,
      component: () => import('./pages/ActivityDetail.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 2,
      },
    },
    {
      path: 'upload',
      name: `${baseUrl}-upload`,
      component: () => import('./pages/Upload.vue'),
      meta: {
        title: PAGE_TITLE,
        rank: 1,
      },
    },
    // {
    //   path: 'works',
    //   name: `${baseUrl}-works`,
    //   component: () => import('./pages/Works.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //     rank: 1,
    //   },
    // },
    // {
    //   path: 'worksdetail',
    //   name: `${baseUrl}-worksdetail`,
    //   component: () => import('./pages/WorksDetail.vue'),
    //   meta: {
    //     title: PAGE_TITLE,
    //     rank: 2,
    //   },
    // },
  ],
};

export default route;
